<div class="wrapper">
    <app-header></app-header>
    <app-left-bar></app-left-bar>
    <app-footer></app-footer>
</div>